import { defineComponent, h } from 'vue'

/**
 * A Quality Assurance route's component, loaded in one step.
 *
 * QA's routes used to load QaGate.vue, which then loaded the page through defineAsyncComponent.
 * Every page draws its own AppLayout, so between the gate's chunk and the page's chunk nothing was
 * rendered, sidebar and top bar included, and the whole window blinked white on opening QA.
 *
 * Here the router awaits the page and the "under development" screen together, before it renders
 * anything, so the route swaps like any other. Which one shows is still decided at render time from
 * isOn(), so switching QA on or off in Global Settings takes effect as it did through the gate. The
 * server refuses QA's API while it is off (EnsureQaEnabled): this is what the page shows, not what
 * protects it.
 */
export function qaPage(loadPage, isOn, loadComingSoon) {
    let component = null

    return async () => {
        if (component) return component

        const [page, comingSoon] = await Promise.all([loadPage(), loadComingSoon()])
        const Page = page.default ?? page
        const ComingSoon = comingSoon.default ?? comingSoon

        component = defineComponent({
            name: 'QaGate',
            inheritAttrs: false,
            setup(_, { attrs }) {
                return () => isOn()
                    ? h(Page, attrs)
                    : h(ComingSoon, { label: 'Quality Assurance', noun: 'page' })
            },
        })

        return component
    }
}
